export var FORGE_CONFIGS_FOR_STREAMS = {
    development: {
        key: "d5d13967400e13144043e04bad677f16",
        secret: "9a2b07b5ff34b95c4edf977dd4b481c2"
    },
    staging: {
        key: "d5d13967400e13144043e04bad677f16",
        secret: "9a2b07b5ff34b95c4edf977dd4b481c2"
    },
    production: {
        key: "7d9ef25b4b49660f32737f085c9c86a1",
        secret: "7c294fcb43b79912dcec7a49dc600331"
    }
};
